<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark"><i class="nav-icon fas fa-user-unlock"></i> Perfil de Usuários <small>Listagem de Perfil de Usuários</small></h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active"><i class="nav-icon fas fa-user-unlock"></i> Perfil de Usuários</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline">
                    <div class="card-header">
                        <h3 class="card-title"> Listagem de Perfil de Usuários</h3>

                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
                                <i class="fas fa-minus"></i>
                            </button>
                            <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <router-link class="btn btn-app" :to="{ name: 'form-usuario_grupo', params: { id: 0 }}">
                                <i class="fas fa-user-unlock"></i> Cadastrar Perfil de Usuário
                            </router-link>
                        </div>
                        <client-table :options="options">
                            <thead class="table-secondary">
                                <tr>
                                    <th>Nome do Perfil</th>
                                    <th>Tipo do Perfil</th>
                                    <th class="min-tablet" style="width: 70px;">Status</th>
                                    <th class="min-tablet" style="width: 70px;">Ações</th>
                                </tr>
                            </thead>
                        </client-table>
                    </div>
                    <div class="card-footer">
                    </div>
                    <div class="overlay">
                        <a class="btn btn-app bg-secondary">
                            <i class="fas fa-spinner fa-pulse"></i> carregando...
                        </a>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>
        <!-- /.content -->
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                options: {
                    "title": "Perfil de Usuários",
                    "ajax": {
                        "url": "/api/usuario_grupo/datatable",
                        "data": function (d) {
                            return JSON.stringify($.extend({}, d, {
                            }));
                        }
                    },
                    "order": [[2, "desc"], [0, "asc"]],
                    "columns": [
                        { "mData": 'nome_grupo' }, 
                        { 
                            "mData": 'tipo_grupo',
                            "mRender": function (data) {
                                switch(data) {
                                    case "A":
                                        return "<b>Administrador</b>";
                                    default:
                                        return "Restrito";
                                } 
                            }
                        },
                        {
                            "bSortable": true,
                            "mData": "status_usuario_grupo",
                            "sClass": "text-center py-0",
                            "mRender": function (data) {
                                if (data == true)
                                    return '<span class="badge badge-success">Ativo</span>';
                                else
                                    return '<span class="badge badge-danger">Inativo</span>';
                            }
                        },
                        {
                        "bSortable": false,
                            "mData": null,
                                "sClass": "text-center py-0",
                                    "mRender": function (data, type, full) {
                                        return `<div class="btn-group">
                                            <button onclick="$(this).trigger('edit', ${full.id_usuario_grupo})" rel="tooltip" title="Editar" class="btn bg-gradient-primary btn-sm"><i class="fas fa-pencil-alt"></i></button>
                                        </div>`;
                                    }
                        }
                    ]
                }
            };
        },
        mounted: function () {
            const vm = this;

            $("body").on("edit", function (event, id) { vm.$router.push({ name: 'form-usuario_grupo', params: { id: id } }).catch(() => { }); });
        }
    };
</script>

<style scoped>
</style>